module.exports = __webpack_public_path__ + "img/header.00e12fa.png";